export class Notifications {
    severity: AlertType;
    summary: string;
    detail: string;
    notify?: boolean;
    link?: any;
}

export enum AlertType {
    success,
    info,
    warn,
    error
}